module.exports = __webpack_public_path__ + "img/catologo.469526ed.svg";